<template>

    <div class="social-confirm"></div>

</template>

<script>
    export default {
        name: 'social-confirm',

        props: ['token'],

        data() {
            return {}
        },

        methods: {
            sendToken() {
                this.$api('GET', '/oauth/check/' + this.token).then((response) => {
                    if (response.status === 200) {
                        // success
                    }
                }).catch((error) => {
                    console.log(error)
                    this.$router.push({name: 'login'})
                })
            }
        },

        mounted() {
            this.sendToken()
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Authentication/Social/SocialConfirm/SocialConfirm.vue